<script>
import { mask } from 'vue-the-mask';

export default {
  directives: {
    mask: (el, binding) => {
      if (! binding.value) {
        return;
      }

      mask(el, binding);
    },
  },

  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },

    value: {
      type: [
        String, Number,
      ],
      required: false,
      default: '',
    },

    mask: {
      type: [
        String, Array,
      ],
      required: false,
      default: null,
    },

    placeholder: {
      type: String,
      required: false,
      default: '',
    },

    type: {
      type: String,
      required: false,
      default: 'text',
    },

    required: {
      type: Boolean,
      required: false,
      default: false,
    },

    error: {
      type: String,
      required: false,
      default: null,
    },

    color: {
      type: String,
      required: false,
      default: 'indigo-500'
    },
  },

  computed: {
    classes () {
      if (this.error) {
        return 'form-input bdk-block bdk-w-full bdk-pr-10 bdk-border-red-300 bdk-text-red-900 bdk-placeholder-red-300 focus:bdk-outline-none focus:bdk-ring-red-500 focus:bdk-border-red-500 sm:bdk-text-sm bdk-rounded-md';
      }

      return `form-input bdk-shadow-sm focus:bdk-ring-${this.color} focus:bdk-border-${this.color} bdk-block bdk-w-full sm:bdk-text-sm bdk-border-gray-300 bdk-rounded-md`;
    },
  },
};
</script>

<template>
  <div
    class="checkout-input"
  >
    <label
      v-if="label"
      v-text="__(label)"
      class="bdk-block bdk-text-sm bdk-font-medium bdk-text-gray-700 bdk-text-left"
    />

    <div
      class="bdk-mt-1"
    >
      <input
        :type="type"
        v-mask="mask"
        :value="value"
        :class="classes"
        :required="required"
        :placeholder="__(placeholder)"
        @input="$emit('input', $event.target.value)"
      >
    </div>

    <span
      v-if="error"
      v-text="error"
      class="bdk-mt-2 bdk-text-sm bdk-text-red-600"
    />
  </div>
</template>

<style lang="scss" scoped>
  .checkout-input {
    width: 100%;

    input {
      outline: none !important;
    }
  }
</style>
